import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import useFilterData from '../../../hooks/useFilterData';
import useSortableData from '../../../hooks/useSortableData';
import { exportCSVFile, exportXlsx } from '../../../utils/exportFile'; // Importa a função inteligente da utils
import Button from '../../bootstrap/Button';
import FormGroup from '../../bootstrap/forms/FormGroup';
import Input from '../../bootstrap/forms/Input';
import Icon from '../../icon/Icon';
import PaginationButtons, { dataPagination } from '../../PaginationButtons';
import Modal, { ModalHeader, ModalBody } from '../../bootstrap/Modal';
import ModalSectorPdf from '../../modals/SectorPdf/modalSector';



const TableCustom = ({ columns, rows, keyExtractor, noShowHeader, title, noShowPagination = false, fontSize, icon, titlePdf, fileName }) => {
	const [search, setsearch] = useState('');
	const dataFilter = useFilterData(rows, search);
	const [currentPage, setCurrentPage] = useState(1);
	const [perPage, setPerPage] = useState(10);
	const { items, requestSort, getClassNamesFor } = useSortableData(dataFilter);
	const onCurrentPageData = dataPagination(items, currentPage, perPage);
	const [showExportModal, setShowExportModal] = useState(false);
	const [openModalEvent, setOpenModalEvent] = useState(false);

	const handleOpenModalEvent = () => {
		setOpenModalEvent(true);
	};
	const handleCloseModalEvent = () => {
		setOpenModalEvent(false);
	};

	useEffect(() => [search, rows]);

	const onExport = useCallback(() => {
		setShowExportModal(true);
	}, []);

	const onExportCSV = useCallback(() => {
		const dataExport = dataFilter.map((row) => {
			const data = {};
			columns.forEach((c) => {
				if (c.noExport) return;
				const field = c.field;
				let cell = c.formatExport
					? c.formatExport(field === '{row}' ? row : row[field])
					: row[field];
				cell = cell === undefined ? ' ' : cell;
				data[c.label.toUpperCase()] = cell;
			});
			return data;
		});
		exportCSVFile(dataExport, fileName || 'dados');
	}, [columns, dataFilter, fileName]);

	const onExportXLSX = async () => {
		const visibleColumns = columns.filter(c => !c.noExport);

		exportXlsx(dataFilter, visibleColumns, fileName || 'dados');
	};

	const columnsRender = useMemo(() => columns.filter(c => !c.hidden), [columns]);

	const dataPDF = [{
		fontSize: fontSize,
		title: titlePdf,
		icon: icon,
		columns: columns,
		data: rows,
	}];

	return (
		<>
			<div className='d-flex' style={{ marginBottom: 20 }} >
				{title && <h4>{title}</h4>}
				{!noShowHeader &&
					<div className='d-flex flex-grow-1 flex-row-reverse'>
						<Button
							style={{ marginLeft: 20, paddingTop: 0, paddingBottom: 0 }}
							className='text-dark'
							type='button'
							color='warning'
							icon="Download"
							hoverShadow="sm"
							shadow="sm"
							size="sm"
							onClick={onExportXLSX}
						>
							Exportar
						</Button>
						<FormGroup id="name" label="" className='col-md-3'>
							<Input
								onChange={e => {
									setsearch(e.target.value);
									if (currentPage !== 1) {
										setCurrentPage(1);
									}
								}}
								value={search}
								placeholder='Buscar'
							/>
						</FormGroup>
					</div>}
			</div>

			<Modal
				id={'modal-export'}
				isOpen={showExportModal}
				setIsOpen={setShowExportModal}
				isStaticBackdrop={true}
				isCentered={true}
				size="md"
			>
				<ModalHeader className="modal-title">
					<h3 className="fw-bold">Exportar</h3>
					<button type="button" className="btn-close" onClick={() => setShowExportModal(false)}></button>
				</ModalHeader>
				<ModalBody>
					<div className='d-flex justify-content-center align-items-center gap-2'>
						<Button
							className="bg-danger text-white fs-5 col-md-4"
							onClick={handleOpenModalEvent}
						>
							<Icon icon='PictureAsPdf' size={'2x'} /> PDF
						</Button>
						<Button
							className="bg-success text-white fs-5 col-md-4"
							onClick={onExportCSV}
						>
							<Icon icon='LibraryBooks' size={'2x'} /> CSV
						</Button>
						<Button
							className="bg-success text-white fs-5 col-md-4"
							onClick={onExportXLSX}
						>
							<Icon icon='LibraryBooks' size={'2x'} /> XLS
						</Button>
					</div>
				</ModalBody>
			</Modal >

			<div className='table-responsive'>
				<table className='table table-modern'>
					<thead>
						<tr>
							{columnsRender.map((column) => (
								<th key={'tab-head-' + column.label} onClick={() => requestSort(column.field)}>
									{column.label.toUpperCase()}
									<Icon
										size='sm'
										className={getClassNamesFor(column.field)}
										icon='FilterList'
									/>
								</th>
							))}
						</tr>
					</thead>
					<tbody>
						{onCurrentPageData.map((item, index) => (
							<tr key={keyExtractor ? keyExtractor(item) : item?.id}>
								{columnsRender.map((c, index2) => {
									let cellValue;
									try {
										cellValue = c.format ? c.format(item) : item[c.field];
										
										if (typeof cellValue === 'string') {
											cellValue = cellValue.trim();
										}
										
										if (cellValue === undefined || cellValue === null || cellValue === '') {
											cellValue = 'N/I';
										}
									} catch (error) {
										cellValue = 'N/I';
									}
									return (
										<td key={`tab-cell-${item?.id}-${index}-${index2}`}>
											{cellValue}
										</td>
									);
								})}
							</tr>
						))}
					</tbody>
				</table>
			</div>

			<ModalSectorPdf
				open={openModalEvent}
				setIsOpen={setOpenModalEvent}
				setIsClose={handleCloseModalEvent}
				data={dataPDF}
				fileName={fileName}
			/>

			{!noShowPagination &&
				<PaginationButtons
					data={items}
					label='items'
					setCurrentPage={setCurrentPage}
					currentPage={currentPage}
					perPage={perPage}
					setPerPage={setPerPage}
				/>
			}
		</>
	);
};

export default memo(TableCustom);